var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 26.584,
    viewBox: "0 0 30 26.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(-766 -908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57",
    "data-name": "Trazado 57",
    d: "M795.063,909.9h-3.75v-.949a.944.944,0,0,0-.938-.949h-2.812a.944.944,0,0,0-.938.949v.949h-11.25v-.949a.944.944,0,0,0-.937-.949h-2.812a.944.944,0,0,0-.938.949v.949h-3.75a.943.943,0,0,0-.937.949v22.786a.943.943,0,0,0,.937.95h28.125a.944.944,0,0,0,.938-.95V910.848A.944.944,0,0,0,795.063,909.9Zm-6.563,0h.938v1.9H788.5Zm-15.937,0h.938v1.9h-.938Zm21.562,22.786h-26.25V911.8h2.812v.949a.944.944,0,0,0,.938.95h2.813a.944.944,0,0,0,.937-.95V911.8h11.25v.949a.943.943,0,0,0,.938.95h2.812a.944.944,0,0,0,.938-.95V911.8h2.812Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_58",
    "data-name": "Trazado 58",
    d: "M780.749,928h-3.8a.95.95,0,0,0-.95.95v3.8a.95.95,0,0,0,.95.95h3.8a.95.95,0,0,0,.95-.95v-3.8A.95.95,0,0,0,780.749,928Zm-.95,3.8h-1.9v-1.9h1.9Z",
    transform: "translate(-5.327 -10.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_59",
    "data-name": "Trazado 59",
    d: "M796.749,928h-3.8a.95.95,0,0,0-.95.95v3.8a.95.95,0,0,0,.95.95h3.8a.95.95,0,0,0,.95-.95v-3.8A.95.95,0,0,0,796.749,928Zm-.95,3.8h-1.9v-1.9h1.9Z",
    transform: "translate(-13.849 -10.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_60",
    "data-name": "Trazado 60",
    d: "M812.749,928h-3.8a.95.95,0,0,0-.95.95v3.8a.95.95,0,0,0,.95.95h3.8a.95.95,0,0,0,.95-.95v-3.8A.95.95,0,0,0,812.749,928Zm-.95,3.8h-1.9v-1.9h1.9Z",
    transform: "translate(-22.372 -10.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_61",
    "data-name": "Trazado 61",
    d: "M780.749,944h-3.8a.95.95,0,0,0-.95.95v3.8a.95.95,0,0,0,.95.95h3.8a.95.95,0,0,0,.95-.95v-3.8A.95.95,0,0,0,780.749,944Zm-.95,3.8h-1.9v-1.9h1.9Z",
    transform: "translate(-5.327 -18.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_62",
    "data-name": "Trazado 62",
    d: "M796.749,944h-3.8a.95.95,0,0,0-.95.95v3.8a.95.95,0,0,0,.95.95h3.8a.95.95,0,0,0,.95-.95v-3.8A.95.95,0,0,0,796.749,944Zm-.95,3.8h-1.9v-1.9h1.9Z",
    transform: "translate(-13.849 -18.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_63",
    "data-name": "Trazado 63",
    d: "M812.749,944h-3.8a.95.95,0,0,0-.95.95v3.8a.95.95,0,0,0,.95.95h3.8a.95.95,0,0,0,.95-.95v-3.8A.95.95,0,0,0,812.749,944Zm-.95,3.8h-1.9v-1.9h1.9Z",
    transform: "translate(-22.372 -18.914)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.bb454f9f0546868a9b42e06bb8809acb.svg";
export { ForwardRef as ReactComponent };